import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'app'

const getUsersState = (state: RootState) => state.common.users

export const getUserActions = createSelector(
  getUsersState,
  users => users.userActions
)

export const getUserDetails = createSelector(
  getUsersState,
  users => users.userDetails
)

export const getAccountantState = createSelector(
  getUsersState,
  users => users.accountant
)

export const getDeleteAccountantState = createSelector(
  getUsersState,
  users => users.deleteAccountant
)

export const getAssignAccountantState = createSelector(
  getUsersState,
  users => users.assignAccountant
)

export const getCompanyDataState = createSelector(
  getUsersState,
  users => users.companyData
)

export const getEditCompanyState = createSelector(
  getUsersState,
  users => users.editCompany
)

export const getUserConfigState = createSelector(
  getUsersState,
  users => users.userConfig
)

export const getFetchUserConfigState = createSelector(
  getUsersState,
  users => users.getUserConfig
)

export const getCurrentSubscriptionState = createSelector(
  getUsersState,
  state => state.currentSubscription
)

export const getBankAccounts = createSelector(
  getUsersState,
  state => state.bankAccounts
)

export const getNotificationSettings = createSelector(
  getUsersState,
  state => state.notificationSettings
)
